import { Config } from '..';
import { uuid } from '../base';
import { ConfigRepository } from '../repository/ConfigRepository';


class ConfigKey {
  static MULTI_CURRENCY_ACTIVE = "MULTI_CURRENCY_ACTIVE";
  static KEY = "KEY";
}

class DefaultConfig {

  private static _configs:Record<string, Config> = DefaultConfig.defaultConfigs();

  private static defaultConfigs() :Record<string, Config> {
    const configs:Record<string, Config> = {};
    configs[ConfigKey.MULTI_CURRENCY_ACTIVE] = new Config({uuid: "", key: ConfigKey.MULTI_CURRENCY_ACTIVE, value: "false", valueType: "boolean"});
    configs[ConfigKey.KEY] = new Config({uuid: "", key: ConfigKey.KEY, value: "", valueType: "string"});
    return configs;
  }

  static getConfig(key: string) : Config {
    return DefaultConfig._configs[key];
  }

  static getAllConfigs() : Config[] {
    return Object.values(DefaultConfig._configs);
  }
}


class Configurations {
  private _configRepo: ConfigRepository;

  constructor(configRepo:ConfigRepository) {
    this._configRepo = configRepo;
  }

  isMultiCurrencyActive() : boolean {
    const key = ConfigKey.MULTI_CURRENCY_ACTIVE;
    const config = this._configRepo.findConfig(key) || DefaultConfig.getConfig(key)
    const value : boolean = JSON.parse(config.value); 
    return value;
  }

  setMultiCurrencyActive(value: boolean) {
    const key = ConfigKey.MULTI_CURRENCY_ACTIVE;
    const config = this._configRepo.findConfig(key) || DefaultConfig.getConfig(key);
    const modifiedKv = config.builder()
      .uuid(config.uuid || uuid())
      .value(value)
      .build();
    this._configRepo.put(modifiedKv.uuid, modifiedKv);
  }

  setValue(value: string) {
    const config = this._configRepo.findConfig(ConfigKey.KEY) || DefaultConfig.getConfig(ConfigKey.KEY);
    const modifiedKv = config.builder()
      .uuid(config.uuid || uuid())
      .value(value)
      .build();
    this._configRepo.put(modifiedKv.uuid, modifiedKv);
  }
}

export { Configurations }